import React from 'react';
import { LinkInterface } from 'atomic/link/link.interface';
import getButtonClasses from 'atomic/button/button.helper';
import getLinkClasses from './link.helper';

import './link.scss';

const Link: React.FC<LinkInterface> = ({
    className,
    size = 'md',
    color = 'secondary',
    block = false,
    uppercase = false,
    weight = '500',
    type = 'link',
    noWrap,
    children,
    ariaLabel,
    styles = {},
    ...rest
}) => {
    const classes = type === 'button'
        ? getButtonClasses({ color, block, uppercase, size, weight, noWrap })
        : getLinkClasses({ color, block, uppercase, size, weight, noWrap });

    return (
        <a
            className={`${classes} ${className || ''}`}
            aria-label={ariaLabel}
            style={styles}
            {...rest}
        >
            {children}
        </a>
    );
};

export default Link;
